<template>
    <v-layout row wrap>
        <v-flex xs12 v-show="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    {{'Equipment Health'|translate}} : {{equipment}}
                    <v-spacer></v-spacer>
                    <equipment-context-menu :equipment="equipment" :date-range="dateRange" v-if="!embeddedMode"
                                            fault model-summary notification-breakdown equipment-summary
                    >
                        <v-list-tile @click="exportAll()">
                            <v-list-tile-title>{{'Export as PDF'|translate}}</v-list-tile-title>
                        </v-list-tile>
                    </equipment-context-menu>
                </v-card-title>
                <div class="carnot-equip-health-holder">
                <v-layout row wrap class="pl-3">
                    <v-flex xs12 md6 class="pt-3">
                        <v-layout v-if="fullEquip" row wrap>
                            <v-flex md6>
                                <p v-if="fullEquip.equipment_id"><strong>{{'Equipment ID'|translate}} : </strong>{{fullEquip.equipment_id}}</p>
                                <p v-if="fullEquip.equipment_name"><strong>{{'Equipment Name'|translate}} : </strong>{{fullEquip.equipment_name}}</p>
                                <p v-if="fullEquip.equipment_type"><strong>{{'Equipment Type'|translate}} : </strong>{{fullEquip.equipment_type}}</p>
                            </v-flex>
                            <v-flex md6>
                                <p v-if="fullEquip.floor"><strong>{{'Floor'|translate}} : </strong>{{fullEquip.floor}}</p>
                                <p v-if="fullEquip.notes"><strong>{{'Notes'|translate}} : </strong>{{fullEquip.notes}}</p>
                            </v-flex>
                            <v-flex md6 v-for="plot in plots">
                                <a @click="showRelVars(plot)"><vue-plotly :data="plot.data"  :layout="plot.layout" :options="{}"  /></a>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 md6 v-if="fullEquip&&fullEquip.graphic_id">
                        <equipment-graphic-renderer :graphic-id="fullEquip.graphic_id" :selected-equipments="[equipment]"></equipment-graphic-renderer>
                    </v-flex>
                    <v-flex xs12 md6 v-if="fullEquip&&!fullEquip.graphic_id">
                        <v-layout row wrap>
                            <v-flex xs12 v-for="plot in tsPlots">
                                <vue-plotly :data="plot.data"  :layout="plot.layout" :options="{}"/>
                            </v-flex>
                        </v-layout>
                    </v-flex>

                </v-layout>
                    <v-layout  row wrap>
                        <v-flex xs12 v-if="fullEquip&&fullEquip.graphic_id">
                            <v-layout row wrap>
                                <v-flex xs12 md6 v-for="plot in tsPlots">
                                    <vue-plotly :data="plot.data"  :layout="plot.layout" :options="{}"/>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12>
                            <notifications :equipment-filter="equipment" :date-range="dateRange"></notifications>
                        </v-flex>
                        <v-flex xs12>
                            <maintenance-record :equipment-filter="equipment" :date-range="dateRange"></maintenance-record>
                        </v-flex>
                    </v-layout>
                    <v-dialog v-model="dialog" max-width="1200">
                        <v-card flat v-if="dialog">
                            <v-card-title class="primary white--text headline">{{relVarTitle}} : {{"Relevant Variables"|translate}}</v-card-title>
                            <data3-chart v-for="(unitVars,unitName) in relVars" :key="'rv'+unitName"
                                         :layout-overrides="{title:'',height:300,margin:layoutOverrides.margin,yaxis:{title:unitName,fixedrange: true},showlegend: true,legend:{...layoutOverrides.legend},xaxis:{...layoutOverrides.xaxis},hovermode:layoutOverrides.hovermode,hoverlabel:layoutOverrides.hoverlabel}"
                                         :on-only="false"
                                         :x-axis="'timestamp'"
                                         disable-responsive
                                         :show-export="false"
                                         ref="rvplots"
                                         just-plot
                                         :data-payload="unitVars"
                                         :date-range="dateRange"></data3-chart>
                        </v-card>
                    </v-dialog>
                </div>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import moment from 'moment'
    import Notifications from "./Notifications";
    import MaintenanceRecord from "./MaintenanceRecord";
    import EquipmentContextMenu from "../components/EquipmentContextMenu";
    import EquipmentGraphicRenderer from "../components/EquipmentGraphicRenderer";
    import VuePlotly from "../components/VuePlotly";
    import printer from "../components/mixins/printer";
    import unitResolver from "../components/mixins/unitResolver";
    import Data3Chart from "@/components/Data3Chart";
    import {getIssues, getRule} from '@/helper'
    export default {
        name: 'EquipmentHealth',
        components: {Notifications,MaintenanceRecord,EquipmentContextMenu,EquipmentGraphicRenderer,VuePlotly,Data3Chart},
        mixins:[printer,unitResolver],
        props: {
            embeddedMode: {type: Boolean, default: false},
            equipmentNamePreset: {type: String, default: null},
        },
        data () {
            return {
                loading:true,
                equipment:null,
                dialog:false,
                relVars:[],
                fullEquip:null,
                relVarTitle:null,
                dateRange: {
                    start:moment().subtract(30, "days").format('YYYY-MM-DD HH:mm:ss'),
                    end: moment().format('YYYY-MM-DD HH:mm:ss')
                },
                plots:[],
                tsPlots:[],
                applicableRules:{},
                layoutOverrides:{
                    xaxis: {
                        title: '',
                    },
                    yaxis:{
                        fixedrange: true
                    },
                    margin:{
                        t: 30,
                        b:0
                    },
                    height:300,
                    showlegend:true,
                    legend: {
                        orientation:'h',
                        y: -0.2,
                    },
                    hoverlabel: {
                        namelength: -1
                    },
                    hovermode:"x",
                }
            }
        },
        methods:{
            showRelVars(plot){
                if(plot.relVars&&Object.keys(plot.relVars).length>0){
                    this.relVars=JSON.parse(JSON.stringify(plot.relVars))
                    this.relVarTitle=plot.relVarTitle
                    this.dialog=true
                }
            },
            jumpToNotification(value,facet) {
                let output = {
                    path: '/notification-breakdown',
                    query:{
                        rangeStart: this.dateRange.start,
                        rangeEnd: this.dateRange.end,
                    }
                }
                output.query[facet]=value
                this.$router.push(output)
            },
            async exportAll(){
                let title = this.$store.state.pointsListStore.pointsList.facility_name + "=" + this.equipment+ "=" + this.dateRange.end
                await this.printPage('.carnot-equip-health-holder', title)
            },
        },
        async beforeMount(){
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            this.equipment = this.embeddedMode ? this.equipmentNamePreset : _.get(this.$route.query, 'equipment', null)
            let rangeStart = _.get(this.$route.query, 'rangeStart', null)
            let rangeEnd = _.get(this.$route.query, 'rangeEnd', null)
            if (!!rangeStart) {
                this.dateRange = {start: rangeStart, end: rangeEnd}
            } else if(maxDate){
                this.dateRange={
                    start:moment(maxDate).subtract(30, "days").format('YYYY-MM-DD HH:mm:ss'),
                    end: moment(maxDate).format('YYYY-MM-DD HH:mm:ss')
                }
            }
        },
        async mounted(){
            for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                if (this.$store.state.pointsListStore.pointsList.equipment_details[i].equipment_name===this.equipment){
                    this.fullEquip=this.$store.state.pointsListStore.pointsList.equipment_details[i]
                    break
                }
            }
            let ruleDf = await getRule({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
            })
            this.applicableRules=ruleDf.result.filter(x=>x.active_status==="active"&&x.topic==="equipment health"&& (x.equipment_group == null || (typeof x.equipment_group === "string" && x.equipment_group.trim() === "")  || x.equipment_group===this.fullEquip.equipment_type))
            let df = await getIssues(
                this.equipment,
                this.$store.state.pointsListStore.pointsList.facility_name,
                this.dateRange
            )
            let issueSeries={}
            let timeAxis = [];
            let ts = moment(this.dateRange.start).format('YYYY-MM-DD HH:mm:ss')
            let end = moment(this.dateRange.end).format('YYYY-MM-DD HH:mm:ss')
            while (ts <= end) {
                timeAxis.push(ts)
                ts = moment(ts).add(this.$store.getters.minutesBetweenSamples, 'minutes').format('YYYY-MM-DD HH:mm:ss')
            }
            let applicableIssues=this.applicableRules.map(x=>x.title)
            for (let index in df.issue){
                if(applicableIssues.indexOf(df.issue[index])>=0){
                    if (!issueSeries[df.issue[index]]){
                        issueSeries[df.issue[index]]={
                            name:df.issue[index],
                            x:timeAxis,
                            y:new Array(timeAxis.length).fill(null)
                        }
                    }
                    let foundtsi=timeAxis.indexOf(df['timestamp'][index])
                    issueSeries[df.issue[index]].y[foundtsi]=df['value'][index]
                }
            }
            this.tsPlots=Object.values(issueSeries).map((series)=>{
                let applicableRule=this.applicableRules.filter(x=>x.title===series.name)[0]
                return{
                data:[series],
                layout:{
                    title:series.name,
                    xaxis: {
                        title: '',
                    },
                    yaxis:{
                        range: [applicableRule.meta.kpiThresholds[0].range[0],applicableRule.meta.kpiThresholds[applicableRule.meta.kpiThresholds.length-1].range[1]],
                        tickmode: "array",
                        tickvals: [applicableRule.meta.kpiThresholds[0].range[0],...applicableRule.meta.kpiThresholds.map(x=>x.range[1])]
                    },
                    margin:{
                        t: 50,
                        b:50
                    },
                    height:300,
                    showlegend:false,
                    hoverlabel: {
                        namelength: -1
                    },
                    hovermode:"closest",
                }
            }})
            this.plots=this.applicableRules.filter(x=>issueSeries[x.title]).map((rule)=>{
                let value=issueSeries[rule.title] ? issueSeries[rule.title].y.reduce((acc, curr) => curr!==null ? curr : acc) : rule.meta.kpiThresholds[0].range[0]
                let relevantVariables = rule.relevant_variables&&rule.relevant_variables!=='0'&&rule.relevant_variables!=='' ? rule.relevant_variables.split(',').map(x=>x.trim()) : [];
                let relVarList={};
                for (let varName of relevantVariables){
                    if(varName.indexOf(" - ")>-1){
                        let extVarName=varName.split(" - ")[1]
                        let extEquipName=varName.split(" - ")[0]
                        let unit = this.getUnit(extVarName,extEquipName)
                        if (!unit){
                            unit=""
                        }
                        if (!relVarList[unit]) {
                            relVarList[unit] = [];
                        }
                        let unitpad= unit&&unit!=="" ? " ("+unit+")" : ""
                        relVarList[unit].push({
                            'filters': {
                                equipment_name: extEquipName,
                                sensor_name: extVarName,
                                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                            },
                            pipeline: [
                                {
                                    type: "calculate",
                                    formula: 'df["' + varName + '"]',
                                    name: varName + unitpad,
                                    "remove_others": true
                                }
                            ],
                            seriesOverrides: {
                                type: 'scatter',
                                opacity: 1,
                                xbins: {
                                    size: 1
                                },
                                ybins: {
                                    size: 1
                                }
                            },
                        })
                    } else {
                        let unit = this.getUnit(varName)
                        if (!unit){
                            unit=""
                        }
                        if (!relVarList[unit]) {
                            relVarList[unit] = [];
                        }
                        let unitpad = unit && unit !== "" ? " (" + unit + ")" : ""
                        relVarList[unit].push({
                            'filters': {
                                equipment_name: this.equipment,
                                sensor_name: varName,
                                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                            },
                            pipeline: [
                                {
                                    type: "calculate",
                                    formula: 'df["' + this.equipment + ' - ' + varName + '"]',
                                    name: varName  + unitpad,
                                    "remove_others": true
                                }
                            ],
                            seriesOverrides: {
                                type: 'scatter',
                                opacity: 1,
                                xbins: {
                                    size: 1
                                },
                                ybins: {
                                    size: 1
                                }
                            },
                        })
                    }
                }
                let foundThresh=rule.meta.kpiThresholds.filter(x=>value>=x.range[0]).reverse()[0]
                let foundStatus=foundThresh ? " : "+foundThresh.status : ""
                return{
                    data:[
                        {
                            type: "indicator",
                            mode: "gauge+number",
                            value: value,
                            title: { text: rule.title +foundStatus, font: { size: 18 } },
                            gauge: {
                                bar: { color: "white" },
                                axis: { range: [rule.meta.kpiThresholds[0].range[0],rule.meta.kpiThresholds[rule.meta.kpiThresholds.length-1].range[1]] },
                                bordercolor: "white",
                                steps: rule.meta.kpiThresholds
                            }
                        }
                    ],
                    layout:{
                        height: 300,
                    },
                    relVars:relVarList,
                    relVarTitle:rule.title
                }})
            this.loading=false
        }

    }
</script>
